import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';

export function newMaskForLayer({
  width,
  height,
}: {
  width: number;
  height: number;
}) {
  return new Uint8Array(width * height);
}

export function copyMask(rawMask: Uint8Array) {
  return new Uint8Array(rawMask);
}

/**
 * Optimization: make a version of this function that takes separate X, Y
 * coordinates instead of a `Point2D`. This sped up floodfill significantly. We
 * generally prefer passing around `Point2D` otherwise.
 */
// eslint-disable-next-line max-params-unless-injectable -- if you need to modify this code, fix this first
export function setPixelXY(
  x: number,
  y: number,
  code: number,
  imageSize: {
    width: number;
    height: number;
  },
  mask: Uint8Array,
) {
  if (isPointInLayerXY(x, y, imageSize)) {
    mask[toMaskPositionXY(x, y, imageSize)] = code;
  }
}

export function pointsBetween(
  [startX, startY]: Point2D,
  [endX, endY]: Point2D,
) {
  const dx = endX - startX;
  const dy = endY - startY;
  const step = 1 / Math.max(Math.abs(dx), Math.abs(dy));
  const intermediatePoints = [] as Point2D[];

  for (let factor = 0; factor <= 1; factor += step) {
    const point = [
      Math.ceil(startX + dx * factor),
      Math.ceil(startY + dy * factor),
    ] as Point2D;
    intermediatePoints.push(point);
  }

  return intermediatePoints;
}

export function toMaskPosition(
  [x, y]: Point2D,
  imageSize: {
    width: number;
    height: number;
  },
) {
  return toMaskPositionXY(x, y, imageSize);
}

/**
 * Optimization: make a version of this function that takes separate X, Y
 * coordinates instead of a `Point2D`. This sped up floodfill significantly. We
 * generally prefer passing around `Point2D` otherwise.
 */
export function toMaskPositionXY(
  x: number,
  y: number,
  imageSize: {
    width: number;
    height: number;
  },
) {
  return y * imageSize.width + x;
}

export function isPointInLayer(
  [x, y]: Point2D,
  imageSize: {
    width: number;
    height: number;
  },
) {
  return isPointInLayerXY(x, y, imageSize);
}

/**
 * Optimization: make a version of this function that takes separate X, Y
 * coordinates instead of a `Point2D`. This sped up floodfill significantly. We
 * generally prefer passing around `Point2D` otherwise.
 */
export function isPointInLayerXY(
  x: number,
  y: number,
  imageSize: {
    width: number;
    height: number;
  },
) {
  return x >= 0 && x < imageSize.width && y >= 0 && y < imageSize.height;
}
